"use client";

import Image from "next/image";
import { useTranslations } from "next-intl";

const NAMESPACE = "new-aluminum-extrusion";
const IMAGE_BASE = "/image/new-version/more/AluminumExtrusion/aluminum-extrusion-finishes";

const FINISHES = [
	{ keyPrefix: "finishesAnodizing", image: "anodizing.webp" },
	{ keyPrefix: "finishesPowderCoating", image: "powder-coating.webp" },
	{ keyPrefix: "finishesElectrophoresis", image: "electrophoresis.webp" },
	{ keyPrefix: "finishesBrushedFinish", image: "brushed-finish.webp" },
	{ keyPrefix: "finishesBeadBlasting", image: "bead-blasting.webp" },
	{ keyPrefix: "finishesPainting", image: "painting.webp" },
	{ keyPrefix: "finishesSilkScreenPrinting", image: "silk-screen-printing.webp" },
	{ keyPrefix: "finishesLaserEngraving", image: "laser-engraving.webp" },
] as const;

export default function AluminumExtrusionFinishes() {
	const t = useTranslations(NAMESPACE);

	return (
		<section className="bg-[#ededed] py-8 sm:py-10 md:py-12 lg:py-16">
			<div className="container">
				<header className="mb-6 text-center sm:mb-8 md:mb-10 lg:mb-12">
					<h2 className="mb-3 text-2xl font-bold leading-tight text-black sm:mb-4 sm:text-[30px] md:text-4xl">
						{t("finishesTitle")}
					</h2>
					<p className="text-sm leading-relaxed text-black md:text-base">{t("finishesDesc")}</p>
				</header>

				<div className="grid border border-[#bfbfbf] bg-white sm:grid-cols-2 lg:grid-cols-4">
					{FINISHES.map((finish) => (
						<article
							key={finish.keyPrefix}
							className="border-b border-[#bfbfbf] bg-[#f3f3f3] p-6 last:border-b-0 lg:border-r lg:[&:nth-child(-n+4)]:border-b lg:[&:nth-child(4n)]:border-r-0 sm:[&:nth-last-child(-n+2)]:border-b-0 lg:[&:nth-last-child(-n+4)]:border-b-0"
						>
							<h3 className="mb-4 text-base font-bold text-black sm:text-lg">
								{t(`${finish.keyPrefix}Title`)}
							</h3>
							<div className="relative mb-4 aspect-[4/3] w-full overflow-hidden bg-[#f5f7fa]">
								<Image
									src={`${IMAGE_BASE}/${finish.image}`}
									alt={t(`${finish.keyPrefix}ImageAlt`)}
									fill
									className="object-cover"
									sizes="(max-width: 640px) 100vw, (max-width: 1024px) 50vw, 25vw"
								/>
							</div>
							<p className="text-sm leading-relaxed text-black">{t(`${finish.keyPrefix}Desc`)}</p>
						</article>
					))}
				</div>
			</div>
		</section>
	);
}
